<template>
  <!-- Main -->
  <div id="main" v-if="true || initialized">
    <!-- 推播 -->
    <div id="mainNotification">
      <div class="areaH">
        <div class="areaV">
          <div class="box">
            <div class="item">
              <span class="title"> {{ $t('AccountSettingDefault.Notification.Order_Notification') }}</span>
              <!-- <a class="add" @click="openAddDialog()">
                <FontAwesomeIcon icon="plus" />
              </a> -->
            </div>

            <div 
              class="item" 
              v-for="(subscriber, index) in emailSubscriberList"
              :key="'email_' + index"
            >
              <div class="number" style="margin-left: 10px;">
                <input
                  class="input"
                  type="email"
                  placeholder="Email Address"
                  :value="subscriber.subscriberIdentifier"
                  disabled="true"
                />
              </div>
              <a class="remove" @click="unsubscribe(subscriber, 'qc')">
                <font-awesome-icon icon="trash"/>
              </a>
            </div>
            <div class="item">
              <div class="number" style="margin-left: 10px;">
                <input
                  class="input"
                  type="email"
                  name="qc-subscriber-email"
                  placeholder="Email Address"
                  v-model="email"
                  @keyup.enter="subscribe(errors.has('qc-subscriber-email'), 'qc')"
                  v-validate="'email'" data-vv-as="qc-subscriber-email"
                />
              </div>
              <a class="save" @click="subscribe(errors.has('qc-subscriber-email'), 'qc')" 
                :style="{ 'color': email || isProgressing ? 'red': 'gray', 'pointer-events': email || isProgressing ? 'auto': 'none'}">
                <font-awesome-icon icon="plus"/>
              </a>
      
            </div>
            <span style="margin-left: 15px; color: red" v-if="errors.has('qc-subscriber-email')"> {{ errors.first('qc-subscriber-email') }}</span>



          </div>
        </div>
      </div>

      <div class="areaH">
        <div class="areaV">
          <div class="box">
            <div class="item">
              <span class="title"> {{ $t('AccountSettingDefault.Notification.VAS_Notification') }}</span>
            </div>

            <div 
              class="item" 
              v-for="(subscriber, index) in vas.emailSubscriberList"
              :key="'email_' + index"
            >
              <div class="number" style="margin-left: 10px;">
                <input
                  class="input"
                  type="email"
                  placeholder="Email Address"
                  :value="subscriber.subscriberIdentifier"
                  disabled="true"
                />
              </div>
              <a class="remove" @click="unsubscribe(subscriber, 'vas')">
                <font-awesome-icon icon="trash"/>
              </a>
            </div>
            <div class="item">
              <div class="number" style="margin-left: 10px;">
                <input
                  class="input"
                  type="email"
                  name="vas-subscriber-email"
                  placeholder="Email Address"
                  v-model="vas.email"
                  @keyup.enter="subscribe(errors.has('vas-subscriber-email'), 'vas')"
                  v-validate="'email'" data-vv-as="vas-subscriber-email"
                />
              </div>
              <a class="save" @click="subscribe(errors.has('vas-subscriber-email'), 'vas')" 
                :style="{ 'color': vas.email || vas.isProgressing ? 'red': 'gray', 'pointer-events': vas.email || vas.isProgressing ? 'auto': 'none'}">
                <font-awesome-icon icon="plus"/>
              </a>
      
            </div>
            <span style="margin-left: 15px; color: red" v-if="errors.has('vas-subscriber-email')"> {{ errors.first('vas-subscriber-email') }}</span>



          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  updateSubscriber
} from "src/javascripts/generalPages/updateForConsoleLog";
import {
  removeSubscriber
} from "src/javascripts/generalPages/deleteForConsoleLog";
import { fetchSubscribers } from "src/javascripts/generalPages/fetchForConsoleLog";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  components: {
    FontAwesomeIcon,
  },
  data() {
    return {
      initialized: false,
      isProgressing: false,
      emailSubscriberList: [],
      email: "",
      vas: {
        emailSubscriberList: [],
        email: "",
        isProgressing: false,
      }
    }
  },
  props: {
    accountId: {
      type: Number,
      default: 1
    },
    value: {
      type: String,
      default: ""
    }
  },
  computed: {
    type() {
      return this.$route.params.type || 'gaa';
    }
  }, 
  created: async function() {
    // fetch subscibers
    await this.getQcSubscribersSetting();
    await this.getVasSubscribersSetting();
    this.initialized = true;
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },

    async getQcSubscribersSetting() {
      try {
        const subscribers = await fetchSubscribers(this.accountId, this.type, 'qc');

        if (subscribers.data) {
          this.emailSubscriberList = subscribers.data.filter(
            subscriber => subscriber.channelType === 'email'
          );
        } else {
          this.emailSubscriberList = [];
        }

      } catch (e) {
        this.emailSubscriberList = [];
        this.$message({
          type: "error",
          message: this.$t('AccountSettingAdvance.Message.Failed_to_get_qc_subscriber_info', {accountId: this.accountId})
        });
      }
    },

    async getVasSubscribersSetting() {
      try {
        const subscribers = await fetchSubscribers(this.accountId, this.type, 'vas');

        if (subscribers.data) {
          this.vas.emailSubscriberList = subscribers.data.filter(
            subscriber => subscriber.channelType === 'email'
          );
        } else {
          this.vas.emailSubscriberList = [];
        }

      } catch (e) {
        this.vas.emailSubscriberList = [];
        this.$message({
          type: "error",
          message: this.$t('AccountSettingAdvance.Message.Failed_to_get_vas_subscriber_info', {accountId: this.accountId})
        });
      }
    },

    async subscribe(error, subscribeType) {
      console.log('subscribe ' + this.email);
      const email = subscribeType === 'vas' ? this.vas.email : this.email;
      const emailSubscriberList = subscribeType === 'vas' ? this.vas.emailSubscriberList : this.emailSubscriberList;
      if (
        !email ||
        error ||
        this.isProgressing
      )
        return;

      if (
        emailSubscriberList.find(
          subscriber => subscriber.subscriberIdentifier === email
        ) 
      ) {
        this.$message({
          type: "error",
          message: this.$t('AccountSettingAdvance.Message.Duplicate_subscription', )
        });
        return;
      }
        
      try {
        this.isProgressing = true;
        const data = {
          channelType: 'email',
          subscriberIdentifier: email,
        };
        
        await updateSubscriber(this.accountId, this.type, subscribeType, data);
        if (subscribeType === 'vas') {
          await this.getVasSubscribersSetting();
        } else {
          await this.getQcSubscribersSetting();
        }
        
      } catch (err) {
        console.error('bindEmail err:', err);
        this.editError('新增信箱失敗');
      } finally {
        this.email = '';
        this.isProgressing = false;
      }
    },

    async unsubscribe(subscriber,  subscribeType) {
      console.log('unsubscribe ',  subscriber);
      try {
        await removeSubscriber(this.accountId, this.type, subscribeType, subscriber);
        if (subscribeType === 'vas') {
          this.vas.emailSubscriberList = this.vas.emailSubscriberList.filter(
            s => s.subscriberId !== subscriber.subscriberId
          );
        } else {
          this.emailSubscriberList = this.emailSubscriberList.filter(
            s => s.subscriberId !== subscriber.subscriberId
          );
        }
        
      } catch (err) {
        console.error('unbindEmail err:', err);
        this.editError('刪除信箱失敗');
      }
    },

    editSuccess(res, label) {
      console.log(res);
      this.$message({
        type: "success",
        message: this.$t('AccountSettingAdvance.Message.Update_successfully', { label })
      });
    },

    editError(err) {
      this.$message({
        type: "error",
        message: this.$t('AccountSettingAdvance.Message.Update_failed')
      });
    }
  },
  // watch: {
  //   editList: function(newVal, oldVal) {
  //     console.log("editList newVal: ", newVal);
  //     if (newVal.length > 0) {
  //       let editStatusData = {
  //         value: this.value
  //       };
  //       this.$emit("edit-status", editStatusData);
  //     } else {
  //       let savedStatusData = {
  //         value: this.value
  //       };
  //       this.$emit("saved-status", savedStatusData);
  //     }
  //   }
  // }
};
</script>
<style scoped src="../../../../../src/assets/css/shop-console.css"></style>
